import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '@shared/components/button/button.component';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { HelperService } from '../../services/helper.service';
import { HTTP_ERRORS } from '@shared/constants/enums.const';
import { ActivatedRoute } from '@angular/router';
import { Error404Component } from './error-404/error-404.component';

@Component({
  selector: 'app-error-page',
  imports: [
    NgOptimizedImage,
    TranslateModule,
    ButtonComponent,
    Error404Component,
  ],
  templateUrl: './error-page.component.html',
  styleUrl: './error-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorPageComponent implements OnInit {
  BUTTON_TYPES = BUTTON_TYPES;
  HTTP_ERRORS = HTTP_ERRORS;

  errorCode = 0;

  constructor(
    private HELPER: HelperService,
    private route: ActivatedRoute,
  ) {}


  ngOnInit() {
    this.route.paramMap.subscribe(paramMap => {
      const code = Number(paramMap.get('CODE')) || 0;
      if (this.HELPER.enumArr(HTTP_ERRORS).includes(code)) {
        this.errorCode = code;
      } else {
        this.HELPER.goUrl('home');
      }
    });
  }

  goHome() {
    this.HELPER.goUrl('home');
  }
}
